import { HttpClient } from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { SocialLogin } from '@capgo/capacitor-social-login';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../../../services/auth/auth.service';

@Component({
  selector: 'app-apple-login',
  standalone: true,
  imports: [TranslocoDirective],
  templateUrl: './apple-login.component.html',
  styleUrl: './apple-login.component.scss',
})
export class AppleLoginComponent implements OnInit {
  authService = inject(AuthService);
  messageService = inject(MessageService);
  translocoService = inject(TranslocoService);
  http = inject(HttpClient);
  router = inject(Router);
  messageDialog: any = {
    login: {
      summary: '',
      ok: { details: '' },
      error: { details: '' },
    },
    serverError: {
      summary: '',
      ok: { details: '' },
      error: { details: '' },
    },
  };
  platform: string = '';
  private readonly destroy$ = new Subject<void>();
  @Output() loginSuccess = new EventEmitter<void>();
  @ViewChild('appleButtonContainer', { static: false }) appleButtonContainer!: ElementRef;

  ngOnInit(): void {
    this.platform = Capacitor.getPlatform();

    if (this.platform === 'ios') {
      this.loadTranslations();

      SocialLogin.initialize({
        apple: {
          clientId: 'com.apprezzoo.service',
        },
      });
    }
  }
  private loadTranslations(): void {
    this.translocoService
      .selectTranslateObject('message')
      .pipe(takeUntil(this.destroy$))
      .subscribe((translations) => {
        this.messageDialog.login.summary = translations.login.summary;
        this.messageDialog.login.error.details = translations.login.error.details;
        this.messageDialog.login.ok.details = translations.login.ok.details;
        this.messageDialog.serverError.summary = translations.serverError.summary;
        this.messageDialog.serverError.error.details = translations.serverError.error.details;
      });
  }
  handleAppleSignIn(response: any) {
    this.authService
      .appleLogin({
        token: response.token,
        code: response.code,
        profile: response.profile,
      })
      .subscribe({
        next: () => {
          this.loginSuccess.emit();
          this.messageService.add({
            severity: 'success',
            summary: this.messageDialog.login.summary,
            detail: this.messageDialog.login.ok.details,
            life: 3000,
          });
          this.router.navigate(['dashboard']);
        },
        error: (err) => {
          console.error('Error on response of social login', err);
          if (!err?.networkError) {
            this.messageService.add({
              severity: 'error',
              summary: this.messageDialog.login.summary,
              detail: this.messageDialog.login.error.details,
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: this.messageDialog.serverError.summary,
              detail: this.messageDialog.serverError.error.details,
            });
          }
        },
      });
  }

  async login() {
    let res;
    try {
      res = await SocialLogin.login({
        provider: 'apple',
        options: {},
      });
    } catch (ex) {
      console.error('Error on social login', ex);
      return;
    }
    // Id token contains the code of the user session of apple, in the token there is the data of the json web token
    // https://developer.apple.com/documentation/signinwithapple/configuring-your-webpage-for-sign-in-with-apple
    this.handleAppleSignIn({
      token: res.result.idToken,
      code: res.result.accessToken?.token,
      profile: res.result.profile,
    });
  }
}
